import React from "react";

export default function Row(props) {
    return (
        <tr className={props.className ? props.className : ""}>
            {props.children}
        </tr>
    );
}
